import { TwitterPicker } from "react-color"
import { useState } from "react"
import InfoPopover from "../infoPopover/infoPopover"
import { useLanguage } from "../../contexts/LanguageContext"
import "../../ressource/css/components/colorPicker.css"

/**
 * Color picker component with Twitter-style color palette.
 * Displays color swatch and opens picker on click with overlay.
 * @param {Object} props
 * @param {Object} props.element - Configuration element
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @param {boolean} props.overlayChecked - Overlay checkbox state
 * @param {Function} props.onToggleOverlay - Overlay checkbox toggle function
 * @param {boolean} props.highlightStrokeChecked - Highlight stroke checkbox state
 * @param {Function} props.onToggleHighlightStroke - Highlight stroke checkbox toggle function
 * @returns {JSX.Element}
 */
function ColorPicker({ element, parameters, setParameters, overlayChecked, onToggleOverlay, highlightStrokeChecked, onToggleHighlightStroke }) {
  const [displayCP, setDisplayCP] = useState(false)
  const { t } = useLanguage()

  const colorValue = element && parameters ? parameters[element.id] : undefined

  /**
   * Updates selected color in parameters.
   * @param {Object} color - Color object with hex property
   */
  const handleChange = color => {
    if (setParameters && element && parameters) setParameters({ ...parameters, [element.id]: color.hex })
  }
  const handleReset = () => {
    if (setParameters && element) setParameters({ ...(parameters || {}), [element.id]: [element.default] })
  }

  return (
    <div className="row colorPicker">
      <div className="col-7">
        {element && <InfoPopover element={element} />}
        <span>{element?.label ? t(element.label) : element?.label}</span>
      </div>
      <div className="col">
        {element && (
          <div className="colorpicker-row">
            <div className="swatch" onClick={() => setDisplayCP(!displayCP)} role="button" aria-label="color swatch">
              <div className="swatchColor" style={{ backgroundColor: colorValue }} />
            </div>
            <div className="resetBloc colorpicker-reset" onClick={handleReset} data-testid="reset-button"></div>
            {element?.id === "modalShadowBgColor" && (
              <label className="colorpicker-checkbox">
                <input type="checkbox" checked={!!overlayChecked} onChange={e => onToggleOverlay && onToggleOverlay(e.target.checked)} />
                {t("Color.colorCheckboxOverlayDisplay")}
              </label>
            )}
            {element?.id === "modalHighlightColor" && (
              <label className="colorpicker-checkbox">
                <input type="checkbox" checked={!!highlightStrokeChecked} onChange={e => onToggleHighlightStroke && onToggleHighlightStroke(e.target.checked)} />
                {t("Color.colorCheckboxHighlightStrokeDisplay")}
              </label>
            )}
          </div>
        )}
        {displayCP ? (
          <div className="popover">
            <div className="cover" onClick={() => setDisplayCP(false)} data-testid="color-picker-cover" />
            <TwitterPicker color={colorValue} onChange={handleChange} />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ColorPicker
